export default __webpack_public_path__ + "714af95b388cd9b8535467fd161dbea5.png";